import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

const LoginForm1 = ({ className = "" }) => {
  const navigate = useNavigate();

  const onRectangleClick = useCallback(() => {
    navigate("/22-login-pass");
  }, [navigate]);

  return (
    <section
      className={`self-stretch flex flex-row items-start justify-start py-0 px-10 box-border max-w-full text-left text-base text-dark-text font-text-regular-lowercase ${className}`}
    >
      <div className="flex-1 flex flex-col items-end justify-start gap-[19.5px] max-w-full">
        <div className="self-stretch h-[60px] rounded-81xl bg-light-primary-key-background border-dark-text border-solid border-[2px] box-border flex flex-row items-start justify-start py-[17px] px-[29px] max-w-full">
          <div className="h-[60px] w-[360px] relative rounded-81xl bg-light-primary-key-background border-dark-text border-solid border-[2px] box-border hidden max-w-full" />
          <div className="relative z-[1]">test.email@gmail.com</div>
        </div>
        <div className="self-stretch flex flex-row items-start justify-between py-[18px] pl-[29px] pr-[21px] relative gap-5">
          <div
            className="h-full w-full absolute !m-[0] top-[0px] right-[0px] bottom-[0px] left-[0px] rounded-81xl bg-light-primary-key-background border-light-text border-solid border-[2px] box-border cursor-pointer"
            onClick={onRectangleClick}
          />
          <input
            className="w-[73px] [border:none] [outline:none] bg-[transparent] flex flex-col items-start justify-start pt-0.5 px-0 pb-0 box-border font-text-regular-lowercase text-base text-light-text"
            placeholder="Mật khẩu"
            type="text"
          />
          <img
            className="h-6 w-6 relative overflow-hidden shrink-0 z-[1]"
            alt=""
            src="/remove-red-eye.svg"
          />
        </div>
        <div className="relative text-light-text text-right">Quên mật khẩu</div>
      </div>
    </section>
  );
};

LoginForm1.propTypes = {
  className: PropTypes.string,
};

export default LoginForm1;
